// extracted by mini-css-extract-plugin
export default {"modalContentHeading":"paymentWarning_modalContentHeading__dQrW2","greyBtn":"paymentWarning_greyBtn__2YCql"};